import React from 'react';
import { ACTION_TYPES } from '../../../services/auditLogService';

const ACTION_CONFIG = {
  [ACTION_TYPES?.USER_CREATED]: { color: 'bg-green-100 text-green-700 border-green-200', icon: '👤' },
  [ACTION_TYPES?.ROLE_CHANGED]: { color: 'bg-blue-100 text-blue-700 border-blue-200', icon: '🔄' },
  [ACTION_TYPES?.PM_TOGGLED]: { color: 'bg-purple-100 text-purple-700 border-purple-200', icon: '⚙️' },
  [ACTION_TYPES?.INVITATION_SENT]: { color: 'bg-cyan-100 text-cyan-700 border-cyan-200', icon: '✉️' },
  [ACTION_TYPES?.USER_DEACTIVATED]: { color: 'bg-orange-100 text-orange-700 border-orange-200', icon: '🚫' },
  [ACTION_TYPES?.USER_REACTIVATED]: { color: 'bg-emerald-100 text-emerald-700 border-emerald-200', icon: '✅' },
};

const AuditActionBadge = ({ actionType }) => {
  const config = ACTION_CONFIG?.[actionType] || { color: 'bg-gray-100 text-gray-700 border-gray-200', icon: '📋' };
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border ${config?.color}`}>
      <span>{config?.icon}</span>
      {actionType}
    </span>
  );
};

export default AuditActionBadge;
